<template>
    <div>
        <div>
            <el-form :model="queryParams" ref="queryForm" label-width="90px" :inline="true"  class="demo-form-inline">
                <el-form-item label="开始时间" prop="startDate" >
                    <el-date-picker size="small" clearable  v-model="queryParams.startDate"
                        type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间"
                        :picker-options="pickerStart">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endDate" >
                    <el-date-picker clearable size="small" v-model="queryParams.endDate"
                        type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间" :picker-options="pickerEnd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="客户名称" prop="custName" >
                    <el-select size="small" clearable filterable  style="width: 100%;" v-model="queryParams.custName" placeholder="请选择客户">
                            <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.name"> </el-option>
                        </el-select>
                </el-form-item>
                <el-form-item label="币制" prop="currency" >
                    <el-select  size="small" clearable style="width: 100%;" v-model="queryParams.currency" placeholder="请选择币制">
                        <el-option v-for="item in currencyList" :key="item.id" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="金额" prop="amount" >
                    <el-input size="small" onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" clearable
                        v-model="queryParams.amount" placeholder="请输入金额" ></el-input>
                </el-form-item>
                <el-form-item label="发票号" prop="invoiceNo" >
                    <el-input size="small" clearable
                        v-model="queryParams.invoiceNo" placeholder="请输入发票号" ></el-input>
                </el-form-item>
                <el-form-item label="是否认领" prop="isClaim" >
                    <el-select  size="small" clearable style="width: 100%;" v-model="queryParams.isClaim" placeholder="请选择是否认领">
                        <el-option v-for="item in isClaimList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="note" >
                    <el-input size="small"  clearable v-model="queryParams.note" placeholder="请输入备注" ></el-input>
                </el-form-item>
            <!-- <el-col :span="5">
                <el-form-item label="发票号" >
                    <el-input size="small" v-model="queryParams.fpNo" clearable placeholder="请输入发票号"></el-input>
                </el-form-item>
            </el-col> -->
        
                <!-- <el-form-item label="提单号">
                    <el-input size="small" v-model="queryParams.blNo" clearable placeholder="请输入提单号"></el-input>
                </el-form-item>-->
                <el-form-item label=" ">
                    <el-button size="mini" plain type="danger" icon="el-icon-refresh" @click="reset">重置</el-button>
                    <el-button size="mini" plain  icon="el-icon-search" @click="getData">查询</el-button>
                    <el-button v-if="role === '财务'" plain size="mini" type="primary" icon="el-icon-plus" @click="addCollection">新增</el-button>
                </el-form-item>
            </el-form>
        </div>
        <main>
            <el-table :data="list" height="calc(100vh - 170px)" :cell-style="rowStyle" id="tableId" ref="tableId"
                style="font-size: calc(15vw * 100 / 1920); flex-wrap: nowrap;  margin-top: 0px; overflow-x: auto;">
                <af-table-column label="序号" type="index" width="50" align="center">
                </af-table-column>
                <af-table-column label="客户名称" align="center" >
                    <template slot-scope="scope">
                        <!-- <i class="iconfont icon-bianmubianma"></i> -->
                        <span  style="cursor: pointer">{{ scope.row.custName }}</span>
                    </template>
                </af-table-column>
                <!-- <af-table-column label="提单号" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.blNo }}</span>
                    </template>
                </af-table-column>  -->
                <af-table-column label="币制" align="center" width="80">
                    <template slot-scope="scope">
                        <span>{{ scope.row.currency }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="金额" align="center" width="160">
                    <template slot-scope="scope">
                        <span v-format="'#,##0.00'">{{ scope.row.amount }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="是否认领" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.isClaim }}</span>
                    </template>
                </af-table-column>
                 <af-table-column label="发票号" align="center" width="160">
                    <template slot-scope="scope">
                        <span>{{ scope.row.invoiceNo }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="负责人" align="center" width="160">
                    <template slot-scope="scope">
                        <span>{{ scope.row.manager }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="登记人" align="center" width="160">
                    <template slot-scope="scope">
                        <span>{{ scope.row.createMan }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="登记收款时间" align="center" width="200">
                    <template slot-scope="scope">
                        <span>{{ scope.row.createTime }}</span>
                    </template>
                </af-table-column>
                <!-- <af-table-column label="附件" align="center">
                    <template slot-scope="scope">
                        <span v-for="item in scope.row.attachments " >
                            <el-link type="primary" @click="downloadFile(item)" class="margin_right" > {{ item.annexName }}</el-link>
                        </span>
                    </template>
                </af-table-column> -->
                <af-table-column label="备注" align="center" width="700">
                    <template slot-scope="scope">
                        <span>{{ scope.row.note }}</span>
                    </template>
                </af-table-column>
                <af-table-column label="操作" align="center" width="180" fixed="right" >
                    <template slot-scope="scope">
                        <el-button slot="reference" plain size="mini" icon="el-icon-user" type="primary" style="padding: 3px;"
                        @click="claim(scope.row)" v-if="!scope.row.isClaim">认领</el-button>
                        <el-button slot="reference" plain size="mini" icon="el-icon-user" type="primary" style="padding: 3px;"
                        @click="resetRow(scope.row)"  v-if="(role === '财务' || userName === '刘士方' ) && scope.row.isClaim === '是'" >重置</el-button>
                        <!-- <el-button round size="small" icon="el-icon-edit" type="warning"
                                @click="amendRow(scope.row)">修改</el-button> -->
                        <el-popconfirm confirm-button-text='是的' cancel-button-text='否' icon="el-icon-info"
                            @confirm="deleteRow(scope.row)" icon-color="red" title="确定删除这条操作记录吗？">
                            <el-button  v-if="role === '财务'" slot="reference" plain size="mini" icon="el-icon-delete" type="danger"
                                style="padding: 3px;margin-left: 10px;">删除</el-button>
                        </el-popconfirm>
                        
                    </template>
                </af-table-column>
            </el-table>
        </main>
        <!-- 新增 -->
        <el-dialog title="新增收款台账"  :visible.sync="showCollection" width="40%" :before-closse="closeCollection"
        :close-on-click-modal="false">
                <el-form ref="collectionForm" :model="collectionForm" label-width="80px" :rules="rules" class="demo-ruleForm">
                    <el-form-item label="客户" prop="custName" style="margin-bottom: 20px;">
                        <el-select :filterable="true" style="width: 100%;" v-model="collectionForm.custName" placeholder="请选择客户">
                            <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.name"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="币制" prop="currency" style="margin-bottom: 20px;">
                        <el-select style="width: 100%;" v-model="collectionForm.currency" placeholder="请选择币制">
                            <el-option v-for="item in currencyList" :key="item.id" :label="item.value" :value="item.value"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="金额" prop="amount" style="margin-bottom: 20px;">
                        <el-input size="small" onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" clearable style="width: 100%"
                        v-model="collectionForm.amount" placeholder="请输入金额"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="发票号" prop="invoiceNo" style="margin-bottom: 20px;">
                        <el-input size="small" clearable style="width: 100%"v-model="collectionForm.invoiceNo" placeholder="请输入发票号"></el-input>
                    </el-form-item> -->
                    <el-form-item label="备注" prop="note" style="margin-bottom: 20px;">
                        <el-input type="textarea" v-model="collectionForm.note" placeholder="请输入备注"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="附件">
                        <el-upload class="upload-demo" :action="signSkRecordUrl" :file-list="collectionForm.file" multiple :auto-upload="false"
                        :on-change="handleChange" :on-remove="handleRemove" >
                        <el-button size="small" type="primary">选择文件</el-button>
                    </el-upload>
                    </el-form-item> -->
                </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeCollection">取 消</el-button>
                <el-button type="primary" @click="submitCollection('collectionForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import req from '@/utils/index.js'
import url from '@/config/url2.js'
import url1 from '@/config/url1.js'
export default {
    name: 'collectionLedger',
    data() {
        return {
            pickerStart:{
                disabledDate: time => { 
                // 如果有 结束 日期 要选择结束之前的日期
                    if(this.queryParams.endDate){
                        return (
                        // 结束日期 小于 开始日期（开始日期不能选择 结束日期之后的日期）
                        new Date(this.queryParams.endDate).getTime() < time.getTime() 
                        );
                    }else{
                        // 如果没有结束日期 那么都可以选
                        return false
                    }
                }
            },
            // 结束时间限制范围
            pickerEnd:{
                disabledDate: time => {
                    // 如果有开始日期 
                    if(this.queryParams.startDate){
                        return (
                        // 开始日期 必须大于 结束日期（结束日期不能选择开始之前的日期） 
                        // 而 -3600*24*1000 减去 一天的时间可以选择当天日期
                        (
                            (
                            new Date(this.queryParams.startDate).getTime()
                            )-3600*24*1000
                        )
                        >
                        (time.getTime())
                        );
                    }else{
                        // 如果没有开始日期 都可以选择
                        return false
                    }
                }
            },
            queryParams: {
                startDate: '', //创建时间(开始)
                endDate: '', //创建时间(结束)
                // fpNo: '',
                // blNo: '',
                custName:'',
                currency:'',
                amount:'',
                note:'',
                invoiceNo:'',
                isClaim:'',
            },
            list: [],//列表
            companyList:[], // 客户列表
            currencyList:[], // 币制列表
            signSkRecordUrl:url.signSkRecord, // 上传文件url
            // 当前用户身份
            role:'',
            // 当前用户名称
            userName:'',
            showCollection:false, // 新增窗口显示
            collectionForm:{ // 新增表单
                amount:Number(),
                custName:'',
                currency:'',
                // invoiceNo:'',
                note:'',
                // file:[]
            },
            isClaimList:[
                {value:'是',item:'是'},
            ],
            // 表单规则
            rules: {
                custName: [
                    { required: true, message: '请选择客户', trigger: 'blur' }
                ],
                currency: [
                    { required: true, message: '请选择币制', trigger: 'blur' }
                ],
                amount: [
                    { required: true, message: '请输入金额', trigger: 'blur' },
                    { pattern: /^(?!0(?:\.0*)?$)\d+(?:\.\d+)?$/,  message: '数值不能为 0',trigger: 'blur' }// 正则排除 0
                ],
            }
        }
    },
    // watch: {
    //     "queryParams.startDate": {
    //         handler(val) {
    //             if (val) {
    //                 this.endNoTime = {
    //                     disabledDate(time) {
    //                         const time1 = new Date(val).getTime() - 8.64e7;
    //                         return time.getTime() < time1 || time.getTime() > Date.now()
    //                     }
    //                 }
    //             } else {
    //                 // 当清空时，进行一些默认的设置或恢复初始的禁用规则
    //                 this.endNoTime = {
    //                     disabledDate(time) {
    //                         return time.getTime() > Date.now()
    //                     }
    //                 }
    //             }
    //         }
    //     },
    //     "queryParams.endDate": {
    //         handler(val) {
    //             if (val) {
    //                 this.startNoTime = {
    //                     disabledDate(time) {
    //                         const time1 = new Date(val).getTime()
    //                         return time.getTime() > time1 || time.getTime() > Date.now()
    //                     }
    //                 }
    //             } else {
    //                 this.startNoTime = {
    //                     disabledDate(time) {
    //                         return time.getTime() > Date.now()
    //                     }
    //                 }
    //             }
    //         }
    //     },
    // },
    mounted() {
        this.role = localStorage.getItem('role');
        this.userName = localStorage.getItem('name');
        
        // this.getData()
        this.getCompanyList()
        this.getTypeOption()
    },
    methods: {
        // 重置
        reset(){
            this.queryParams = {
                startDate: '', //创建时间(开始)
                endDate: '', //创建时间(结束)
                // fpNo: '',
                // blNo: '',
                custName:'',
                currency:'',
                amount:'',
                invoiceNo:'',
                note:'',
                isClaim:'',
            }
        },
        // 文件预览
        downloadFile(data){
            const params = {
                path: '/preview',
                query: {
                    annexUrl: data.annexUrl,
                    annexName: data.annexName
                }
            }
            window.open(this.$router.resolve(params).href, '_blank') // 这个就是打开新链接的方式
        },
        deleteRow(row) {
            let URL = `${url.deleteSkById}/${row.id}/`;
            req.delete(URL).then(res => {
                if (res.data.code === 200) {
                    this.$message.success(res.data.message);
                    this.getData();
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        rowStyle() {
            return "text-align:center";
        },
        getData() {
            // 至少一个查询条件
            if ( !this.queryParams.startDate && !this.queryParams.endDate && !this.queryParams.custName && !this.queryParams.currency && !this.queryParams.amount && !this.queryParams.invoiceNo && !this.queryParams.note && !this.queryParams.isClaim) {
                this.$message.error('请至少输入一项查询条件');
                return;
            }
            let URL = `${url.getSkRecords}`;
            req.post(URL, this.queryParams).then(res => {
                if (res.data.code === 200) {
                    // this.$message.success(res.data.message);
                    this.list = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        // 获取客户信息
        getCompanyList(){
            let URL = `${url.getList}/?name=${''}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.companyList = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        //获得币制数据
        getTypeOption() {
            let value = '币制';
            let URL = `${url1.getDicList}/?value=${value}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.currencyList = res.data.data.data;
                }
            })
        },
        // 新增收款台账
        addCollection(){
            this.showCollection = true;
        },
        // 关闭
        closeCollection(){
            this.showCollection = false;
            this.$refs.collectionForm.resetFields();
        },
        // 文件上传时勾子
        // handleChange(file, fileList){
        //     this.collectionForm.file = fileList;
        // },
        // // 移除文件勾子
        // handleRemove(file, fileList){
        //     this.collectionForm.file = fileList;
        // },

        // 提交
        submitCollection(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let fileUrl = `${url.signSkRecord}/?amount=${String(this.collectionForm.amount)}&currency=${this.collectionForm.currency}&note=${this.collectionForm.note}&custName=${this.collectionForm.custName}`
                    // const formData = new FormData();
                    // this.collectionForm.file.forEach(item => {
                    //     formData.append('file', item.raw);
                    // });
                    // req.post(fileUrl,formData).then(res => {
                    req.post(fileUrl).then(res => {
                        if (res.data.code === 200) {
                            this.closeCollection()
                            // this.getData()
                        }else{
                            this.$message({
                                type: 'warning',
                                message: res.data.message
                            });
                            return false;
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        // 认领
        claim(row){
            this.$prompt('请输入发票号', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S+/, // 非空验证
                inputErrorMessage: '发票号不能为空',
            }).then(({ value }) => {
                // const invoiceNoValue = {
                //     invoiceNo: value
                // }
                let URL = `${url.claimSkRecord}/${row.id}/?invoiceNo=${String(value)}`;
                req.post(URL).then(res => {
                    if (res.data.code === 200) {
                        this.getData()
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(() => {    
            });
        },
        // 重置认领
        resetRow(row){
            this.$confirm('是否确认重置认领?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let URL = `${url.resetSkRecord}/${row.id}/`;
                req.post(URL).then(res => {
                    if (res.data.code === 200) {
                        this.getData()
                        this.$message.success(res.data.data);
                    } else {
                        this.$message.error(res.data.data);
                    }
                })
            }).catch(() => {       
            });
        }
    },
}
</script>

<style lang="css" scoped>
.hoverStyle:hover {
    color: rebeccapurple;
    /* 设置悬停时的字体颜色 */
    text-decoration: underline;
    /* 添加下划线 */
}

::v-deep .el-table .el-table__cell {
    padding: 0px 0;
}

::v-deep .cell {
    /* white-space: nowrap; */
    /* overflow: auto; */
    display: inline-block;
}

::v-deep .el-table .cell {
    padding: 0;
}

.el-form-item {
    margin-bottom: 0px;
    align-items: center;
}
::v-deep .el-form-item__label {
    white-space: nowrap;
    display: inline-block;
    vertical-align: middle;
    align-items: center;
}

/* ::v-deep.el-form-item__content {
    display: inline-block;
    vertical-align: middle;
} */

::v-deep .el-pagination {
    padding: 0 !important;
    margin-top: 0 !important;
}

/* .demo-form-inline.el-form-item {
    display: flex;
    align-items: center;
} */
::v-deep .el-table__body tr.current-row>td {
    background-color: #2383e9 !important;
    color: #fff;
}

:v-deep .el-button--mini .el-button--mini.is-round {
    padding: 4 !important;
}

:v-deep .el-main {
    overflow-x: hidden;
}
/* .el-form-item{
    display: flex;
    flex-wrap: nowrap;
} */
 .margin_right{
    margin-right: 10px;
 }
</style>